import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TiktokSpecialCampaignReportSummary.graphql';
import { Query, QuerytiktokSpecialCampaignReportSummaryArgs } from '../../__generated__/globalTypes';

export const useTiktokSpecialCampaignReportSummaryQuery = (
  options?: QueryHookOptions<Query, QuerytiktokSpecialCampaignReportSummaryArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytiktokSpecialCampaignReportSummaryArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTiktokSpecialCampaignReportSummaryLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytiktokSpecialCampaignReportSummaryArgs>
): QueryResult<Query, QuerytiktokSpecialCampaignReportSummaryArgs> & {
  getTiktokSpecialCampaignReportSummary: LazyQueryExecFunction<Query, QuerytiktokSpecialCampaignReportSummaryArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTiktokSpecialCampaignReportSummary, result] = useLazyQuery<
    Query,
    QuerytiktokSpecialCampaignReportSummaryArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTiktokSpecialCampaignReportSummary, ...result };
};

export const useTiktokSpecialCampaignReportSummaryPromiseQuery = () => {
  const client = useApolloClient();

  const getTiktokSpecialCampaignReportSummary = useCallback(
    (options?: Omit<QueryOptions<QuerytiktokSpecialCampaignReportSummaryArgs, Query>, 'query'>) =>
      client.query<Query, QuerytiktokSpecialCampaignReportSummaryArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTiktokSpecialCampaignReportSummary };
};
// Suspense Query Hooks
export const useTiktokSpecialCampaignReportSummarySuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytiktokSpecialCampaignReportSummaryArgs>
) => {
  const result = useSuspenseQuery<Query, QuerytiktokSpecialCampaignReportSummaryArgs>(QUERY, {
    ...options
  });

  return result;
};
